import { apiSalesWeb } from '@shared/config';

export interface ICreateRequestPaymentByCustomerCardIdInput {
  customerCardId: string;
  expirationDate: string;
  confirmationNumber: string;
  companyId: string;
  customerAddress: {
    postalCode: string;
    complement?: string;
    number: string;
    street: string;
    district: string;
    city: string;
    state: string;
  };
}

export interface ICreateRequestPaymentByCustomerCardIdOutput {
  id: string;
}

export function createRequestPaymentByCustomerCardId(
  payload: ICreateRequestPaymentByCustomerCardIdInput,
) {
  return apiSalesWeb.post<ICreateRequestPaymentByCustomerCardIdOutput>(
    `/request-payment/${payload.customerCardId}`,
    payload,
  );
}
